import React, { useState } from 'react';
import { BookMarked, GraduationCap, PlayCircle } from 'lucide-react';
import EnrolledCourses from '../../components/user/EnrolledCourses';
import PortalPageHeader from '../../components/student-portal/PortalPageHeader';
import MyLectures from '../MyLectures';

type Tab = 'courses' | 'lessons';

const tabClass = (active: boolean) =>
  `inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl px-3 text-sm font-bold transition-all sm:flex-none sm:px-5 ${
    active
      ? 'bg-teal-600 text-white shadow-md shadow-teal-700/20'
      : 'border-2 border-teal-100 bg-white text-slate-900 hover:border-teal-300 hover:bg-teal-50'
  }`;

const PortalMyLearning: React.FC = () => {
  const [tab, setTab] = useState<Tab>('courses');

  return (
    <div className="pb-8" dir="rtl">
      <div className="px-4 pt-5 sm:px-6 sm:pt-7 lg:px-8">
        <div className="rounded-2xl border-2 border-teal-100 bg-white px-4 py-5 sm:px-6 sm:py-6">
          <PortalPageHeader
            align="center"
            eyebrow="مساحتك التعليمية"
            title="كورساتي وحصصي"
            description="كورساتك وحصصك في مكان واحد — كمّل من حيث وقفت"
            icon={<BookMarked className="h-4 w-4" />}
          />

          <div className="mx-auto flex max-w-4xl gap-2">
            <button type="button" onClick={() => setTab('courses')} className={tabClass(tab === 'courses')}>
              <GraduationCap className="h-4 w-4 shrink-0" />
              كورساتي
            </button>
            <button type="button" onClick={() => setTab('lessons')} className={tabClass(tab === 'lessons')}>
              <PlayCircle className="h-4 w-4 shrink-0" />
              حصصي
            </button>
          </div>
        </div>
      </div>

      <div className="mt-4">
        {tab === 'courses' ? <EnrolledCourses embedded /> : <MyLectures embedded />}
      </div>
    </div>
  );
};

export default PortalMyLearning;
